import { cn } from '@anytag/shared-utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('animate-pulse rounded-md bg-black-40', className)} {...props} />;
}

const ChatSkeleton = ({ count = 6, className }: { count?: number; className?: string }) => (
  <div className={cn('flex h-full flex-col gap-4 p-4', className)}>
    {Array.from({ length: count }).map((_, index) => {
      const isLeft = index % 2 === 0;
      return (
        <div key={index} className={cn('flex w-full', isLeft ? 'justify-start' : 'justify-end')}>
          <div className={cn('max-w-[75%]')}>
            <div className={cn('flex flex-col gap-2', isLeft ? 'items-start' : 'items-end')}>
              <Skeleton className={cn('h-4 w-32', isLeft ? 'w-48' : 'w-24')} />
              <Skeleton className={cn('h-4', isLeft ? 'w-64' : 'w-48')} />
              <Skeleton className={cn('h-4 w-32', isLeft ? 'w-48' : 'w-24')} />
              {isLeft && <Skeleton className="h-4 w-40" />}
            </div>
          </div>
        </div>
      );
    })}
  </div>
);

export { Skeleton, ChatSkeleton };
